import UI from '../../components/ExcerciseTypes/Design/UserInterface';

const json = {
  1: {
    unit: 'Review 1',
    id: 'SB4-PV-P29-E1',
    audio: '',
    video: '',
    component: UI,
    // exerciseKey: '',
    recorder: true,
    isAllowSubmit: false,
    questionImage: [ // Row
      [
        { url: 'img/FriendsPlus/Page29/E1/1.jpg' },
      ],
      [
        { url: 'img/FriendsPlus/Page29/E1/2.jpg' },
      ]
    ],
  },
  2: {
    unit: 'Review 1',
    id: 'SB4-PV-P29-E2',
    audio: '',
    video: '',
    component: UI,
    // exerciseKey: '',
    recorder: true,
    isAllowSubmit: false,
    questionImage: [ // Row
      [
        { url: 'img/FriendsPlus/Page29/E2/1.jpg' },
      ],
      [
        { url: 'img/FriendsPlus/Page29/E1/2.jpg' },
      ],
      [
        { url: 'img/FriendsPlus/Page29/E2/2.jpg' },
      ]
    ],
  },

  3: {
    unit: 'Review 1',
    id: 'SB4-PV-P29-E3',
    audio: '',
    video: '',
    component: UI,
    // exerciseKey: '',
    recorder: true,
    isAllowSubmit: false,
    questionImage: [ // Row
      [
        { url: 'img/FriendsPlus/Page29/E3/1.jpg' },
      ]
    ],
  },
  4: { // Exercise num
    unit: 'Review 1',
    id: 'SB4-PV-P29-E4',
    audio: '',
    video: '',
    component: UI,
    recorder: true,
    isAllowSubmit: false,
    question: [
    ],
    questionImage: [
      [
        { url: 'img/FriendsPlus/Page29/E4/1.jpg' },
      ],
    ]
  },

}

export default json;